import { getCachedOnboardingProgress, setCachedOnboardingProgress } from './onboardingProgressUtils';
import { apiClientWithMiddleware } from './API';
import { get } from './tempStorage';
const GETTING_STARTED_GROUP_KEY_OVERRIDE = 'GETTING_STARTED_GROUP_KEY_OVERRIDE';
export const getUserOnboardingProgress = portalId => {
  const path = `/usercontext-app/v1/onboarding/progress/summary?portalId=${portalId}`;
  return apiClientWithMiddleware().get(path);
};
export const getPortalOnboardingSettings = portalId => {
  const path = 'onboarding-settings/v1/settings';
  return apiClientWithMiddleware().get(path, {
    query: {
      portalId
    }
  });
};
export const formatOnboardingProgressData = ({
  response,
  settings
}) => {
  const {
    completedTasksCount
  } = response;
  let {
    tasksCount
  } = response;
  const {
    selectedView,
    views
  } = settings;
  let groupKey;
  if (views && views[selectedView]) {
    groupKey = views[selectedView].groupKey;
  }
  try {
    const gettingStartedOverride = get(GETTING_STARTED_GROUP_KEY_OVERRIDE);
    if (gettingStartedOverride === 'experienced' || gettingStartedOverride === 'getting_started_experienced') {
      // A shorter (3 item) checklist shows for certain users. Syncs up the navigation progress bar with this override.
      tasksCount = 3;
    }
  } catch (e) {
    // noop
  }
  const percentageComplete = Math.min(Math.round(completedTasksCount / tasksCount * 100), 100);
  setCachedOnboardingProgress(percentageComplete, selectedView, groupKey);
  return {
    progress: percentageComplete,
    selectedView,
    groupKey
  };
};
export const getFormattedOnboardingProgressData = portalId => {
  const cachedProgress = getCachedOnboardingProgress();
  if (cachedProgress.hasFetched) {
    const {
      progress,
      selectedView,
      groupKey
    } = cachedProgress;
    return Promise.resolve({
      progress,
      selectedView,
      groupKey
    });
  }
  return Promise.all([getUserOnboardingProgress(portalId), getPortalOnboardingSettings(portalId)]).then(([response, settings]) => formatOnboardingProgressData({
    response,
    settings
  }));
};